import { initialState } from '@/Helpers.js';
import moment from '@/plugins/vue-moment.js';

export default class TimePeriodRangeData {
    /**
     * @param {TimePeriod} timePeriod
     */
    constructor(timePeriod = null) {
        if (timePeriod) {
            this.from = timePeriod.nativeDate('from');
            this.to = timePeriod.nativeDate('to');
            this.break_time = timePeriod.break_time;
        } else {
            this.from = null;
            this.to = null;
            this.break_time = 0;
        }
    }

    static fromForm(attributes) {
        const rangeData = new TimePeriodRangeData();

        const timezone = initialState('InstitutionSettings.timezone');

        rangeData.from = moment.utc(attributes.from).tz(timezone).toDate();
        rangeData.to = moment.utc(attributes.to).tz(timezone).toDate();
        rangeData.break_time = attributes.break_time;

        return rangeData;
    }

    toPayload() {
        return {
            from: this.from ? moment(this.from).utc().format('YYYY-MM-DD HH:mm:ss') : null,
            to: this.to ? moment(this.to).utc().format('YYYY-MM-DD HH:mm:ss') : null,
            break_time: this.break_time,
        };
    }

    toForm() {
        return {
            from: this.from,
            to: this.to,
            break_time: this.break_time,
        };
    }

    toTemplatedForm() {
        return {
            apply_from_day: false,
            apply_from_time: false,
            apply_to_day: false,
            apply_to_time: false,
            apply_break_time: false,
            from_day: moment(this.from).isoWeekday(),
            from_time: TimePeriodRangeData.parseTime(this.timeToFormat('from', 'HH:mm:ss')),
            to_day: moment(this.to).isoWeekday(),
            to_time: TimePeriodRangeData.parseTime(this.timeToFormat('to', 'HH:mm:ss')),
            break_time: this.break_time,
        };
    }

    moment(field) {
        return moment(this[field]);
    }

    reset() {
        this.from = null;
        this.to = null;
        this.break_time = 0;
    }

    isValid() {
        return !!this.from && !!this.to;
    }

    timeToFormat(field, format = 'h:mm a') {
        return moment(this[field]).format(format);
    }

    static parseTime(value) {
        return new Date(`01 Jan 1970 ${value}`);
    }
}
